var PageList             = require("ott/image-reader/PageList"),
    PageListArraySupport = require("ott/image-reader/PageListArraySupport"),
    kind                 = require("enyo/kind");

module.exports = kind(/** @lends app.MediaPlayer.Tech.ImageReader.CanvasView.prototype */ {

    /**
     * @private
     */
    name: "app.MediaPlayer.Tech.ImageReader.CanvasView",

    /**
     * @private
     */
    kind: PageList,

    /**
     * @private
     */
    mixins: [PageListArraySupport],

    /**
     * @private
     */
    classes: "app-media-player-image-reader-canvas-view",

    /**
     * No transparency, for speed.
     *
     * @type {?Object}
     * @public
     */
    rendererOptions: {
        alpha: false
    },

    /**
     * @private
     */
    bufferSize: 3,

    /**
     * The dataset feeding this page list.
     *
     * @type {?Array}
     * @public
     */
    data: null,

    /**
     * @private
     */
    handlers: {
        oncontextmenu: "onContextMenu"
    },

    /**
     * Prevent right-click menu.
     *
     * @param    {enyo.Control}  sender  The sender
     * @param    {Object}        event   The event
     * @returns  {boolean}       Whether to stop event propagation.
     * @private
     */
    onContextMenu: function(sender, event) {
        event.preventDefault();

        return false;
    }

});
